import { render, staticRenderFns } from "./ReferralView.vue?vue&type=template&id=7e98addd&scoped=true"
import script from "./ReferralView.vue?vue&type=script&lang=js"
export * from "./ReferralView.vue?vue&type=script&lang=js"
import style0 from "./ReferralView.vue?vue&type=style&index=0&id=7e98addd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e98addd",
  null
  
)

export default component.exports